import React from 'react';
import PropTypes from 'prop-types';

// Components
import { ArrowLeft } from '../../icons/ArrowLeft';
import { ArrowRight } from '../../icons/ArrowRight';

// Styles
import './SliderPagination.scss';

export const SliderPagination = ({ previousSlide, nextSlide, dots, additonalStyling }) => {
    return (
        <div className="slider-pagination">
            <div className={`pagination ${additonalStyling}`}>
                <button
                    className="pagination__button"
                    onClick={previousSlide}
                    aria-label="previous slide"
                >
                    <ArrowLeft />
                </button>
                <ul className="pagination__list">{dots}</ul>
                <button
                    className="pagination__button"
                    onClick={nextSlide}
                    aria-label="next slide"
                >
                    <ArrowRight />
                </button>
            </div>
        </div>
    );
}

SliderPagination.propTypes = {
    previousSlide: PropTypes.func,
    nextSlide: PropTypes.func,
    dots: PropTypes.array,
    additonalStyling: PropTypes.string
  }
  